export function vehicleRequiresBranchSelectionForV1GewaSync(v1Id: number | null | undefined): boolean {
  return typeof v1Id !== "number" || !Number.isSafeInteger(v1Id) || v1Id <= 0;
}
